( function( $ ) {

$(document).ready(function(){

var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
};

function getCookieValue(name) {
  var nameEQ = name + "=";
  var cookies = document.cookie.split(';');
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i].trim();
    if (cookie.indexOf(nameEQ) === 0) {
      return cookie.substring(nameEQ.length, cookie.length); 
    }
  }
  return null;
}

function setCookie(name, value, days) {
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  const expires = "expires=" + date.toUTCString();
  document.cookie = name + "=" + encodeURIComponent(value) + ";" + expires + ";path=/";
}

var discountCode = getCookieValue('discount_code');

if (document.getElementById("two-page-options") && (discountCode)) {
  console.log("Discount code is set:", discountCode);
  $('#discount_input').val( discountCode);
} 

if (document.getElementById("good-better") && (document.cookie.indexOf('discount_code') == -1 ))
 {$('#discountBtn').trigger('click'); }

$('#promo_code_submit').on("click", function(e) {
  e.preventDefault();
  var a = $('#promo_code_modal').val();
  var b = window.location.pathname;
  var c = 'https://ruffgreens.com/discount/' + a + '?redirect=' + b;
  if (a) {
     setTimeout(function() {
        setCookie("discount_code", a, 7);
       $('#discount').css('display', 'none');
       window.location.href = c;
     }, 500);
  }
});

$('#need-code').on( "click", function(e) {
  e.preventDefault();
  $('#discount_drop').show();
});

$('.modal-open').click(function(e) {
   e.preventDefault();
  var a = $(this).attr('data-modal');
  $('#'+a).css('display','block');
});

$('.closer').click(function(e) {
   e.preventDefault();
  $('.modal-two').css('display','none');
});  

$('.ClsBtn').click(function(e) {
   e.preventDefault();
  var a = $(this).attr('data-modal');
  $('#'+a).css('display','none');
});
  
$('.two-pro-inner').click(function(e) {
  $('.two-pro-inner').removeClass('active');
 $(this).addClass('active');
});

$('.good-slide-picker').click(function(e) {
    $('.good-slide-picker').removeClass('active');
    e.preventDefault();
    var a = $(this).attr('id');
    var b = $(this).attr('data-product');
    var c = $(this).attr('data-size'); 
    var d = $(this).attr('data-price'); 
    var e = $(this).position();
    var f = e.left - '2' + 'px';
    $('#good-slider-' + b).css("left", f);
    $('#sub-price').text(d);
    $(this).addClass('active');
});

// Modified to go directly to checkout
$('#add-gift-page').off('click').on('click', function(e) {
  e.preventDefault();
  
  var activeSlider = $('.good-slide-picker.active');
  var size = activeSlider.attr('data-size');
  var variantId = activeSlider.attr('data-variant-id'); // You'll need to add this data attribute
  
  if (!variantId) {
    // Fallback to original URL method if variant ID not available
    var url = 'https://ruffgreens.com/pages/add-your-free-gift?size=' + size;
    window.location.href = url;
    return;
  }
  
  // Add loading state
  var originalText = $(this).html();
  $(this).html('Processing... <i class="fas fa-spinner fa-spin"></i>').prop('disabled', true);
  
  // Add to cart and redirect to checkout
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      'items': [{
        'id': variantId,
        'quantity': 1,
        'properties': {
          '_size': size
        }
      }]
    },
    dataType: 'json',
    success: function(items) {
      if(!document.body.getAttribute('checkout-redirect-block')){
        window.location.href = '/checkout';
      }
    },
    error: function(xhr, status, error) {
      console.error('Error adding to cart:', error);
      // Reset button
      $('#add-gift-page').html(originalText).prop('disabled', false);
      alert('There was an error adding the item to your cart. Please try again.');
    }
  });
});

var size = getUrlParameter('size');
if (size === 'large') {
  $('#size-choice').val('l');
}

$('.faux-tidbits').on("click", function(e) {
  e.preventDefault();
  var a = $(this).attr('data-product');
  var b = $(this).attr('data-plan');
  meowoptions(a,b);
});

function meowoptions(a,b) {
  $('#product_option').val(a);
  $('#selling_plan').val(b);
  $('#submit-table').trigger('click');
}

function twooptions(a,b) {
  document.getElementById('error-message').style.display = 'none';
  
  const expr = a+b; 
  console.log(expr);
  
  var c, sellingPlan, size;
  
  switch (expr) {
    case 'rc':
      c = 40562831917129;
      sellingPlan = 1924333641;
      size = "regular";
      break;
    case 'rn':
      c = 41665079836745;
      sellingPlan = 1924333641;
      size = "regular";
      break;
    case 'rt':
      c = 41665080524873;
      sellingPlan = 1924333641;
      size = "regular";
      break;
    case 'ro':
      c = 41665081180233;
      sellingPlan = 1924333641;
      size = "regular";
      break;
    case 'lc':
      c = 40562831949897;
      sellingPlan = 1956020297;
      size = "large";
      break;
    case 'ln':
      c = 41665080131657;
      sellingPlan = 1956020297;
      size = "large";
      break;
    case 'lt':
      c = 41665080950857;
      sellingPlan = 1956020297;
      size = "large";
      break;
    case 'lo':
      c = 41665081344073;
      sellingPlan = 1956020297;
      size = "large";
      break;
    default:
      document.getElementById('error-message').style.display = 'block';
      c = 'Error';
  }
  
  if (c !== 'Error') {
    $('#bundle_product_option').val(c);
    $('#two-sell').val(sellingPlan);
    $('#sizeer').val(size);
    $("#submit-table").trigger("click");
  }
}

$('#blinker').on("click", function(e) {
  e.preventDefault();
  var s = $('#size-choice').val();
  var p = $('.two-pro-inner.active').data('product');

  if(s == null || p == null) { 
    document.getElementById('error-message').style.display = 'block'; 
  } else {
    twooptions(s,p);
  }
}); 

$('#no-gift').on("click", function(e) {
  e.preventDefault();
  var s = $('#size-choice').val();
  var p = 'o';

  if(s == null || p == null) { 
    document.getElementById('error-message').style.display = 'block'; 
  } else {
    twooptions(s,p);
  }
}); 

$('.good-dropper').click(function(e) {
  e.preventDefault();
  var b = $(this).attr('data-ferris');
  var c = '#'+b+'_block';
  var d = $(this).find('i');
  
  if ($(c).hasClass("active")) {
    // Already active, do nothing or close
  } else {
    $('.good-inner').removeClass('active');
    $(c).addClass('active');
    $(d).toggleClass('fa-minus-circle fa-plus-circle');
  }
});

$('.good-choice').click(function(e) {
  e.preventDefault();
  var x = $(this).attr('id');
  var y = $(this).attr('data-product');
  $('.'+y).removeClass('active');
  $(this).addClass('active');
  option(x,y);
});

function option(x,y) {
  if (opt === 'one_time'){
    var z = $('#'+x).attr('data-price');
    var k = '$'+z;
    $('#'+y+'-price').text(k);
  } else {
    var z = $('#'+x).attr('data-price-auto');
    var k = '$'+z;
    $('#'+y+'-price-auto').text(k);	
  }
}

$('.accord-title').click(function(e) {
  e.preventDefault();
  var m = $(this).attr('id');
  var n = '#'+'accord-'+m;
  
  if ($(this).parent().hasClass('active')) {
    $('.active .accord-content').slideUp();
    $('.flyout-accord-inner').removeClass('active');
  } else {
    $('.active .accord-content').slideUp();
    $('.flyout-accord-inner').removeClass('active');
    $(this).parent().addClass('active');
    $(n).slideDown();
  }
});

$('#flyout-close, #fly-background').click(function(e) {
  e.preventDefault();
  flyout('close','dingle');
});

$('.pro-fly').click(function(e) {
  e.preventDefault();
  var y = $(this).attr('id');
  flyout('open',y);
});

function flyout(x,y) {
  if (x === 'open'){
    $('#fly-background').addClass('show');
    $('#flyout-wrap').addClass('show');
    $('.flyout-product').removeClass('accurate');
    $('#'+y+'-fly').addClass('accurate');
  } else {
    $('#fly-background').removeClass('show');
    $('#flyout-wrap').removeClass('show');
  }
}

$('.thumbs').on("click", function(e) {
  e.preventDefault();
  var a = $(this).data('thumb');
  var c = $(this).attr('id');
  var b = $('#'+c).children('img').attr('src');
  
  if ($(this).hasClass('active')) {
    // Already active
  } else {
    $(this).siblings().removeClass('active');
    $(this).addClass('active');
    $('#'+a+'-main').attr('src', b);
  }
}); 

$(document).on('submit', '.direct-checkout-form', function(e) {
  var checkoutUrl = $(this).find('input[name="return_to"]').val() || '/checkout';
  
  
});

});

} )( jQuery );
// Add this to your existing JavaScript file to force direct checkout

$(document).ready(function() {
    // Intercept ALL product form submissions
    $(document).on('submit', 'form[action*="/cart/add"], .product_form form', function(e) {
        e.preventDefault(); // Stop the normal form submission
        
        var form = $(this);
        var submitBtn = form.find('button[type="submit"], input[type="submit"]');
        
        // Add loading state
        var originalBtnContent = submitBtn.html();
        submitBtn.html('Processing... <i class="fas fa-spinner fa-spin"></i>').prop('disabled', true);
        
        // Get form data
        var formData = form.serialize();
        
        // Submit via AJAX
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: formData,
            dataType: 'json',
            success: function(item) {
                console.log('Product added to cart:', item);
                // Force redirect to checkout immediately
                if(!document.body.getAttribute('checkout-redirect-block')){
                  window.location.href = '/checkout';
                }
            },
            error: function(xhr, status, error) {
                console.error('Error adding to cart:', error);
                
                // Reset button
                submitBtn.html(originalBtnContent).prop('disabled', false);
                
                // Show error
                alert('There was an error adding the item to your cart. Please try again.');
            }
        });
        
        return false; // Ensure form doesn't submit normally
    });
    
    // Also intercept specific button clicks
    $(document).on('click', '.add_to_cart, #submit-table, .trial-button', function(e) {
        e.preventDefault();
        
        // Find the parent form and trigger our custom submission
        var form = $(this).closest('form');
        if (form.length > 0) {
            form.trigger('submit');
        }
        
        return false;
    });
    
    // Handle the gift page button - preserve original functionality
    $('#add-gift-page').off('click').on('click', function(e) {
        e.preventDefault();
        
        var activeSlider = $('.good-slide-picker.active');
        var size = activeSlider.attr('data-size') || 'regular';
        
        // Go to the gift selection page as originally intended
        var giftPageUrl = 'https://ruffgreens.com/pages/add-your-free-gift?size=' + size;
        window.location.href = giftPageUrl;
    });
    
    // If you're on the gift selection page and want to go directly to checkout after selection
    $(document).on('click', '.gift-selection-checkout', function(e) {
        e.preventDefault();
        
        var form = $(this).closest('form');
        if (form.length > 0) {
            // Let the gift selection form submit via AJAX and then redirect to checkout
            var formData = form.serialize();
            
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: formData,
                dataType: 'json',
                success: function(items) {
                    if(!document.body.getAttribute('checkout-redirect-block')){
                      window.location.href = '/checkout';
                    }
                },
                error: function(xhr, status, error) {
                    console.error('Error adding gift to cart:', error);
                    alert('There was an error adding the item to your cart. Please try again.');
                }
            });
        }
    });
});

// Alternative method - redirect after any cart addition
$(document).ajaxSuccess(function(event, xhr, settings) {
  // Check if this was a cart add request
  if (settings.url && settings.url.includes('/cart/add')) {
    console.log('Cart add detected, redirecting to checkout...');
    if(!document.body.getAttribute('checkout-redirect-block')){
      setTimeout(function() {
          window.location.href = '/checkout';
      }, 100);
    }
  }
});